<script>
  import { Reply, Share2, Info } from 'lucide-svelte';
  import Reaction from './Reaction.svelte';
  import ReactionViewer from './ReactionViewer.svelte';

  export let fromMe = false;
  export let messageId;
  export let interactionMode = 'desktop';
  export let currentReaction = null;
  export let reactionSummary = [];
  export let selectionMode = false;
  export let active = false;
  export let alwaysShowReaction = true;
  export let alwaysShowReactionPopup = false;

  export let onReply = () => {};
  export let onShare = () => {};
  export let onDetails = () => {};
  export let onSelectReaction = () => {};

  let reactionPopupOpen = false;
  let reactionViewerOpen = false;

  function handleReactionOpenChange(isOpen) {
    reactionPopupOpen = isOpen;
  }

  function handleReactionViewerOpenChange(isOpen) {
    reactionViewerOpen = isOpen;
  }

  function handleDetailsClick(event) {
    event.preventDefault();
    event.stopPropagation();
    onDetails();
  }
</script>

{#if !selectionMode}
  <div
    class="bubble-actions-wrap bubble-actions-wrap--desktop"
    class:bubble-actions-wrap--active={active || reactionPopupOpen || reactionViewerOpen}
    class:bubble-actions-wrap--always-reaction={alwaysShowReaction || interactionMode === 'mobile'}>
    {#if !reactionPopupOpen && alwaysShowReactionPopup}
      <div class="message-actions {fromMe ? 'message-actions--before' : 'message-actions--after'}">
        <button type="button" class="bubble-action" aria-label="Trả lời" title="Trả lời" on:click={onReply}>
          <Reply size={14} />
        </button>
        <button type="button" class="bubble-action" aria-label="Chia sẻ" title="Chia sẻ" on:click={onShare}>
          <Share2 size={14} />
        </button>
        <button
          type="button"
          class="bubble-action"
          aria-label="Chi tiết"
          title="Chi tiết"
          on:click={handleDetailsClick}>
          <Info size={14} />
        </button>
      </div>
    {/if}

    <div class="message-like {fromMe ? 'message-like--me' : 'message-like--other'}">
      <div class="message-like__content">
        <ReactionViewer
          {messageId}
          {reactionSummary}
          {fromMe}
          {interactionMode}
          onOpenChange={handleReactionViewerOpenChange} />
        <Reaction
          {messageId}
          {fromMe}
          {interactionMode}
          {currentReaction}
          onOpenChange={handleReactionOpenChange}
          onSelect={onSelectReaction} />
      </div>
    </div>
  </div>
{/if}

<style>
  .bubble-actions-wrap {
    position: relative;
    pointer-events: auto;
  }

  .message-actions {
    position: absolute;
    bottom: -0.4rem;
    display: flex;
    align-items: center;
    gap: 0.18rem;
    /* padding: 0.18rem 0.22rem;
    border-radius: 999px;
    border: 1px solid rgba(226, 232, 240, 0.88);
     background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06); */
    opacity: 0;
    pointer-events: none;
    transform: translateY(0) scale(0.96);
    transition:
      opacity 140ms ease,
      transform 140ms ease;
    z-index: 12;
  }

  .message-actions--before {
    right: calc(100% + 1.4rem);
  }

  .message-actions--after {
    left: calc(100% + 1.4rem);
  }

  .message-like {
    position: absolute;
    opacity: 0;
    pointer-events: none;
    transform: scale(0.9);
    transition:
      opacity 140ms ease,
      transform 140ms ease;
    z-index: 15;
    /* border: 1px solid rgba(226, 232, 240, 0.88);
    background: rgba(255, 255, 255, 0.98); */
  }

  .message-like__content {
    display: inline-flex;
    align-items: center;
    gap: 0.18rem;
    white-space: nowrap;
  }

  .message-like--me {
    right: -10px;
    bottom: -28px;
  }

  .message-like--other {
    left: auto;
    right: -8px;
    bottom: -1.8rem;
  }

  .bubble-action {
    display: grid;
    place-items: center;
    width: 1.55rem;
    height: 1.55rem;
    border: 1px solid rgba(226, 232, 240, 0.88);
    background: rgba(255, 255, 255, 0.98);
    border-radius: 999px;
    color: #475569;
    transition:
      color 120ms ease,
      background-color 120ms ease,
      transform 120ms ease;
  }

  .bubble-action:hover {
    color: #0f172a;
    background: rgba(241, 245, 249, 0.96);
    transform: scale(1.15);
  }

  .bubble-actions-wrap--active .message-actions,
  .bubble-actions-wrap--active .message-like,
  .bubble-actions-wrap:hover .message-actions,
  .bubble-actions-wrap:focus-within .message-actions,
  .bubble-actions-wrap:hover .message-like,
  .bubble-actions-wrap:focus-within .message-like {
    opacity: 1;
    pointer-events: auto;
    transform: scale(1);
  }

  .bubble-actions-wrap--always-reaction .message-like {
    opacity: 1;
    pointer-events: auto;
    transform: scale(1);
  }

  @media (hover: none), (pointer: coarse) {
    .bubble-actions-wrap--desktop .message-actions {
      display: none;
    }

    .bubble-actions-wrap--desktop:not(.bubble-actions-wrap--always-reaction) .message-like {
      display: none;
    }
  }

  @media (max-width: 640px) {
    .message-actions {
      padding: 0.16rem 0.2rem;
      gap: 0.14rem;
    }

    .bubble-action {
      width: 1.4rem;
      height: 1.4rem;
    }
  }
</style>
